import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Empowering sales people with technology tools." />

<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/&amp;title=Empowering%20sales%20people%20with%20technology%20tools.&amp;summary=Empowering%20sales%20people%20with%20technology%20tools.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Empowering%20sales%20people%20with%20technology%20tools.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Empowering%20sales%20people%20with%20technology%20tools.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header header--video" id="page-header">
    <div className="header__image" data-video-uri="https://www.youtube.com/embed/7Rmc8RHE91E?autoplay=1&amp;modestbranding=0&amp;rel=0&amp;showinfo=0" data-video-target="#page-header .embed-responsive" data-video-parent="#page-header">
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/Mentor-Large-Tony-Hughes.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Empowering sales people with technology tools.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Tony J. Hughes</li>
                        <li>13 April 2016</li>
                        <li>4:00</li>
                    </ul>
                    <div className="header__icon play-icon">
                        <i className="icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Insight into how the sales world will utilize emerging technology in order to improve selling capability.</h3>
<div className="rich-text"><p>Tony initially comments on four significant new technology trends that are being adopted now and are creating an evolution in selling.  Then he explores three emerging technologies that he believes could revolutionize the way we sell. One example he gives is artificial intelligence. Tony then provides some thoughts on how sales leaders and salespeople need to prepare themselves and their companies for these radical innovations.</p><p><br/></p></div>


  <button type="button" className="btn btn-default" data-toggle="collapse" data-target="#transcript" aria-expanded="false" aria-controls="transcript">View full transcript</button>
  <div className="collapse" id="transcript">
  <h3>Transcript</h3>
  <div className="block-paragraph"><div className="rich-text"><p><strong>John:</strong> Hello! I’m here again with Tony Hughes – my friend, author, speaker, and a thought leader in what’s happening in the sales world. With the idea of thought leadership in mind, Tony, I wanted to ask you a question. I’ve read an article you wrote recently, I thought it was absolutely fascinating, artificial intelligence selling is what you titled it. You talked a little bit about what’s been happening in technology and what’s going to happen in technology in the future, and I thought we’d like to share some of that with our audience right now. What do you see as a real trend that’s happening in technology in relation to selling?</p><p><strong>Tony:</strong> Yeah, thanks John. The thing that really sparked that for me was that I actually read an article on A.I. computing and how it really is in the here and now.</p><p><strong>John:</strong> Right.</p><p><strong>Tony</strong>: It’s no longer science fiction, and it’s going to impact the business world enormously. The thing we all know is that in the last few years the trends have been: “social”, “mobile”, “cloud”, and then also “big data”. [01:00] I know they sound like clichés, but they’ve been the four technology trends that we’ve been talking about that are really driving things. They’re not going to go away, they’re only going to become more important for people, but I think there’s going to be three things that actually get added to that mix.</p><p><strong>John:</strong> What are they?</p><p>Tony: Well, the first one is artificial intelligence. The ability to do predictive analytics, which is the second thing, so applying business intelligence down at a micro predictive level to try and predict buying behaviour. This whole concept of trigger events, so monitoring social media, monitoring the Internet, and actually predicting when are people going into a buying cycle.</p><p><strong>John:</strong> So salespeople themselves are not going to do that, you’re saying that technology’s going to do all that work that salespeople probably did in the past, or at least to some extent.</p><p><strong>Tony:</strong> Well, that’s maybe the scary thing that people would feel, but at the end of the day: people buy from those they like and trust. I think relationship selling will never go away, but the smartest salespeople are going to get very good at using the technology. Whether it’s as simple as monitoring a [02:00] platform, like LinkedIn, to look for trigger events—for example, when someone changes a role: if you look for mergers and acquisitions then you look for scandals in the press if the company’s in some kind of crisis.</p><p>So, the ability to use technology to do a lot of that work for people, buyers a certainly harnessing technology well – I think that sellers in many ways need to actually catch up. So, there’s big data that’s going to morph into micro predictive analytics, there’s business intelligence, and then the third new thing that’s coming along is near field computing: mobility computing where you can tell where people are. Wearable technologies which will work with these predictive analytics tools, more in the B2C world is where the impact will be.</p><p><strong>John:</strong> I was going to say: isn’t that more B2C than B2B?</p><p><strong>Tony:</strong> It is B2C from a selling point of view, but from a productivity point of view and from a service delivery point of view it’s got some big implications for B2B, but all of these things will filter through.</p><p><strong>John:</strong> Okay. So, what does a salesperson and sales managers and sales directors need to [03:00] think about? That is “How do I need to respond to the new technology, to really gain the value and the benefits?”</p><p><strong>Tony:</strong> Well, you raised a really important question a minute ago, which is: can salespeople really use these technologies? And it really is a big…</p><p><strong>John:</strong> Yeah, it frightens me!</p><p><strong>Tony:</strong> Yeah, it really is—it frightened me until recently as well, as far as B2B and social goes. But the reality is that we’ve been talking for years about sales and marketing coming together and working as one. The concept of a Chief Revenue Officer that would sit across sales and marketing, for customer experience and service delivery for that whole end-to-end experience; it’s never been more important. Because I think marketing can use these technologies well and they can support salespeople. So, sales and marketing coming together to equip salespeople with insights, to equip them with early engagement opportunities based on social listening is going to be very important.</p><p><strong>John:</strong> Salespeople I guess don’t necessarily need to become expert in the technology, it’s going to be a tool that will help them.</p><p><strong>Tony:</strong> Yes.</p><p><strong>John:</strong> And so the [04:00] organisations themselves have to make sure they’re investing in that sort of technology, to give the value to the sales guy to do a better job at selling.</p><p><strong>Tony:</strong> Yes, they do. And that’s the scary thing for an organisation. You know, the CEO of an organisation needs to make the decision to let go and empower their people to represent their brand.</p><p><strong>John:</strong> Yes.</p><p><strong>Tony:</strong> And there’s some risk in that, and that’s why cultural alignment of employees with the organisation’s values has never been more important. Because everybody represents the brand, and salespeople need to become micro marketers.</p><p><strong>John:</strong> Great advice, Tony! Thank you very much for your time! I look forward to the next time that we have a discussion, I will learn even more from you. Thank you!</p><p><strong>Tony:</strong> Thanks, John!</p></div></div>
  </div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Tony Hughes" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Tony-Hughes.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Tony J. Hughes</h4>
        <p>MD of RSVPselling</p>
        <Link to="solutions/find-a-mentor/tony-j-hughes" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>Tony Hughes is an international speaker and best selling author with 30
years of sales leadership experience. He is ranked as the most influential
person in professional selling within Asia-Pacific by Top Sales Magazine and
teaches 'modernized selling' within the MBA program at the University of
Technology, Sydney. Tony is also the ‘most read’ LinkedIn Author globally. <br/></p></div>
<Link to="solutions/find-a-mentor/tony-j-hughes" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/&amp;title=Empowering%20sales%20people%20with%20technology%20tools.&amp;summary=Empowering%20sales%20people%20with%20technology%20tools.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Empowering%20sales%20people%20with%20technology%20tools.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Empowering%20sales%20people%20with%20technology%20tools.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/empowering-sales-people-technology-tools/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 